import React from 'react';
import styled from 'styled-components';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const Breadcrumbs = ({ data, onFolderOpen }) => (
  <Container>
    {data.map((item) => (
      <Item key={item.id}>
        <Button onClick={() => onFolderOpen(item.id)}>{item.name}</Button>
      </Item>
    ))}
  </Container>
);

const Container = styled.div`
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  display: flex;
  align-items: center;
  line-height: 24px;
`;

const Button = styled.button`
  ${Mixins.transition('opacity')};
  ${Mixins.resetButton()};
  font-size: 18px;
  font-weight: 500;
  position: relative;
  padding-left: 4px;
  padding-right: 4px;
  color: ${Colors.nobel};
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    opacity: 0.6;
  }
`;

const Item = styled.div`
  display: flex;
  align-items: center;

  &:last-child ${Button} {
    color: ${Colors.coal};
  }

  &:first-child ${Button}:before {
    content: '';
    width: 24px;
    height: 24px;
    margin-right: 8px;
    display: block;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%23D5D5D5' fill-rule='evenodd' d='M4 6v11h16V8h-9.828l-2-2H4zM2 4h7l2 2h11v13H2V4z'/%3E%3C/svg%3E%0A");
    background-size: 24px 24px;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
  }

  &:not(:first-child):before {
    content: '';
    width: 24px;
    height: 24px;
    display: block;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill='%23D5D5D5' fill-rule='nonzero' d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'/%3E%3Cpath d='M0 0h24v24H0z'/%3E%3C/g%3E%3C/svg%3E%0A");
    background-size: 24px 24px;
    background-position: center center;
    background-repeat: no-repeat;
    position: relative;
  }
`;

Breadcrumbs.defaultProps = {
  data: [],
  onFolderOpen: () => {},
};
